export default __webpack_public_path__ + "static/image-highlight-baremetal-report-157259ceb150b0c0c84fefcb2049281d.png";